import Cookies from "js-cookie";

const dynamicLinkBaseUrl = "https://seatfrog.page.link";
const seatfrogUrl = "https://seatfrog.com/home";
const androidPackageName = "au.com.seatfrog.icarus";
const iosBundleId = "com.Seatfrog";
const iosAppStoreId = "1129001637";

const appStoreUrl = "https://itunes.apple.com/app/seatfrog/id1129001637";
const playStoreUrl =
  "https://play.google.com/store/apps/details?id=au.com.seatfrog.icarus";

const gaCookie = Cookies.get("_ga")?.substring(6);
const gaClientId = gaCookie ? gaCookie : null;

function getDynamicAppInstallUrl(desktopUrl) {
  const urlTrackingParams = Array.from(
    new URLSearchParams(window.location.search),
  ).reduce((params, [key, value]) => {
    if (key.startsWith("utm_")) {
      params[key] = value;
    }
    return params;
  }, {});

  // Adding here as this needs to be applied to the link property
  if (gaClientId) {
    urlTrackingParams.client_id = gaClientId;
  }

  // Appending tracking parameters to link property
  const linkUrl = new URL(seatfrogUrl);
  const linkSearchParams = new URLSearchParams({
    ...urlTrackingParams,
  });
  linkUrl.search = linkSearchParams.toString();

  const deferredLinkParams = {
    link: linkUrl.toString(),
    apn: androidPackageName,
    ibi: iosBundleId,
    isi: iosAppStoreId,
    efr: 0,
  };

  if (desktopUrl) {
    deferredLinkParams.ofl = desktopUrl;
  }

  const searchParams = new URLSearchParams({
    ...deferredLinkParams,
    ...urlTrackingParams,
  });

  const dynamicUrl = new URL(dynamicLinkBaseUrl);
  dynamicUrl.search = searchParams.toString();

  return dynamicUrl.toString();
}

// Used for the QR code
export const appInstallUrl = getDynamicAppInstallUrl();

// Used for the "App Store" buttons - caveat that on Android device, this will go to Play Store, not App Store
export const appInstallAppStoreUrl = getDynamicAppInstallUrl(appStoreUrl);

// Used for the "Play Store" buttons - caveat that on iOS device, this will go to the App Store, not Play Store
export const appInstallPlayStoreUrl = getDynamicAppInstallUrl(playStoreUrl);
